




import axios from "axios";

const URL = process.env.REACT_APP_BACKEND_API_URL;

// Create axios instance
const axiosInstance = axios.create({
    baseURL: URL,
    headers: {
        "Content-Type": "application/json"
    }
});

// Request interceptor to add Bearer token
axiosInstance.interceptors.request.use(
    (config) => {
        // Get tokens from localStorage
        const tokens = localStorage.getItem("tokens");

        if (tokens) {
            try {
                const parsedTokens = JSON.parse(tokens);
                const accessToken = parsedTokens.accessToken.jwtToken;

                // Add Bearer token to headers
                if (accessToken) {
                    config.headers.Authorization = `Bearer ${accessToken}`;
                }
            } catch (error) {
                console.error("Error parsing tokens:", error);
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle 401 Unauthorized errors (token expired)
        if (error.response && error.response.status === 401) {
            // Clear localStorage and redirect to login
            localStorage.removeItem("user");
            localStorage.removeItem("tokens");
            window.location.href = "/login/barcode";
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
